export default "__VITE_ASSET__9sTlBGIJ__"